// icons
import { IoLogoFacebook, IoLogoInstagram, IoLogoYoutube } from "react-icons/io";
import { GoPrimitiveDot } from "react-icons/go";
import { RiHeart3Fill, RiHeart3Line } from "react-icons/ri";

const RecipeDetailsComponent = ({
  product,
  addToFavorites,
  deleteFavorite,
  fav,
}) => {
  const {
    recipe,
    cooktime,
    category,
    image,
    ingredients,
    ingredientsNumber,
    instagram,
    instructions,
    meal,
    youtube,
    facebook,
    user,
  } = product;

  return (
    <section className='ftco-section'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-6 mb-5'>
            <img style={{ width: "100%" }} src={image} alt={recipe} />
          </div>
          <div className='col-lg-6 product-details pl-md-5'>
            <h3
              className='d-flex justify-content-between align-items-center'
              style={{ color: "#d63230", fontSize: "2rem", fontWeight: "bold" }}
            >
              {recipe}{" "}
              {fav ? (
                <RiHeart3Fill
                  color='#d63230'
                  style={{ cursor: "pointer" }}
                  onClick={deleteFavorite}
                />
              ) : (
                <RiHeart3Line
                  color='#d63230'
                  style={{ cursor: "pointer" }}
                  onClick={addToFavorites}
                />
              )}
            </h3>
            <p>
              Submited by: <span style={{ color: "#d63230" }}>{user}</span>
            </p>
            <div className='rating d-flex'>
              <p className='text-left mr-4'>
                Cook Time
                <span className='mr-2 d-inline text-primary'> {cooktime}</span>
              </p>
              <p className='text-left mr-4'>
                <span
                  className='mr-2 text-capitalize'
                  style={{ color: "#000" }}
                >
                  <span style={{ color: "#bbb" }}> {category}</span>
                </span>
              </p>
              <p className='text-left'>
                <span className='mr-2' style={{ color: "#000" }}>
                  For{" "}
                  <span style={{ color: "#bbb", textTransform: "capitalize" }}>
                    {meal}
                  </span>
                </span>
              </p>
            </div>
            <p className='price'>
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "1.6rem",
                  fontWeight: "600",
                }}
              >
                {ingredientsNumber} Ingredients
              </span>
            </p>
            <p style={{ marginTop: "-15px", color: "#000" }}>
              {ingredients.map((ing, i) => (
                <span
                  key={i}
                  style={{
                    color: "#666",
                    textTransform: "capitalize",
                    display: "block",
                  }}
                >
                  <GoPrimitiveDot size={12} color='#d63230' /> {ing.value}
                </span>
              ))}
            </p>
            <div className='row mt-4'>
              <div className='col-md-6'>
                <div className='form-group d-flex'>
                  <div className='select-wrap'>
                    <div className='icon'>
                      <span className='ion-ios-arrow-down'></span>
                    </div>
                    {/* <select name='' id='' className='form-control'>
                      <option value=''>Small</option>
                      <option value=''>Medium</option>
                      <option value=''>Large</option>
                      <option value=''>Extra Large</option>
                    </select> */}
                    {facebook !== "" && (
                      <a
                        href={facebook}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='mx-3'
                      >
                        <IoLogoFacebook size={40} color='#4267B2' />
                      </a>
                    )}
                    {instagram !== "" && (
                      <a
                        href={instagram}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='mx-3'
                      >
                        <IoLogoInstagram size={40} />
                      </a>
                    )}
                    {youtube !== "" && (
                      <a
                        href={youtube}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='mx-3'
                      >
                        <IoLogoYoutube size={40} />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <p>
              <span className='btn btn-black py-3 px-5'>Shop Ingredients</span>
            </p>
          </div>
        </div>
        <div className='my-5'>
          <h3>Cooking Instructions</h3>
          <div dangerouslySetInnerHTML={{ __html: instructions }} />
        </div>
      </div>
    </section>
  );
};

export default RecipeDetailsComponent;
